import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Fil d'Ariane" data-testid="breadcrumbs" className="mb-6">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-slate-500">
        <li>
          <Link
            to="/"
            data-testid="breadcrumb-home"
            className="inline-flex items-center gap-1 transition-colors hover:text-[#2BB08A]"
          >
            <Home className="h-3.5 w-3.5" aria-hidden="true" />
            Accueil
          </Link>
        </li>
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <ChevronRight className="h-3.5 w-3.5 text-slate-300" aria-hidden="true" />
            {item.to && i < items.length - 1 ? (
              <Link to={item.to} className="transition-colors hover:text-[#2BB08A]">
                {item.label}
              </Link>
            ) : (
              <span aria-current="page" className="font-medium text-[#0B1F3A]">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
